export const getLinkEntity = (...args) => {
  const [el] = args
  if (!el) return '#'

  const { __typename, id } = el
  if (!__typename || !id) return '#'

  if (__typename === 'Event' && !el?.primaryCategory?.slug) {
    return '#'
  }

  let redirect
  switch (__typename) {
    case 'Hotel':
      redirect = {
        name: 'page-hotel',
        params: { id }
      }
      break
    case 'Audioguide':
      redirect = {
        name: 'page-audioguide',
        params: { id }
      }
      break
    case 'CulturalOrganization':
      redirect = {
        name: 'page-cultural-organization',
        params: { id }
      }
      break
    case 'EventOrganizer':
      redirect = {
        name: 'page-event-organizer',
        params: { id }
      }
      break
    case 'Event':
      redirect = {
        name: 'page-event',
        params: { id, categorySlug: el.primaryCategory.slug }
      }
      break
    case 'Guide':
      redirect = {
        name: 'page-guide',
        params: { id }
      }
      break
    case 'Route':
      redirect = {
        name: 'page-route',
        params: { id }
      }
      break
    case 'TouristAgency':
      redirect = {
        name: 'page-tourist-agency',
        params: { id }
      }
      break
    default:
      redirect = '#'
  }
  return redirect
}
